import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionIdMatch) {
      navigate('/');
      return;
    }

    const sessionId = sessionIdMatch[1];
    const redirectTo = localStorage.getItem('cg-auth-redirect') || '/commande';
    localStorage.removeItem('cg-auth-redirect');

    (async () => {
      try {
        const { data } = await axios.post(`${API}/api/auth/google-session`, { session_id: sessionId });
        const user = {
          id: data.id,
          name: data.name,
          email: data.email,
          phone: data.phone || '',
          type: data.type || 'individual',
          company: data.company || '',
          picture: data.picture || '',
          token: data.token,
        };
        localStorage.setItem('cg-customer', JSON.stringify(user));
        // Clean the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        navigate(redirectTo);
      } catch {
        navigate('/');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-[#F78A7D]/30 border-t-[#F78A7D] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm" style={{ color: 'var(--color-muted-fg)' }}>Connexion en cours...</p>
      </div>
    </div>
  );
}
